import { format } from "date-fns";
import React from "react";
import styled from "styled-components";
import Icon from "./Icon";
import { useTranslation } from "react-i18next";

const DaySwitchBase = styled.div`
  background-color: #fff;
  border-radius: 10px;
  padding: 10px 20px;
  font-family: Roboto, sans-serif;
  display: flex;
  justify-content: space-between;
  user-select: none;
`;

const DaySwitchArrow = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 10px;
  cursor: pointer;
`;

interface DaySwitchProps {
  value?: number;
  onChange?: (value: number) => void;
  max?: number;
  min?: number;
  date: Date;
}

/**
 * Day-step selector for navigating per-day form sections.
 * Controlled by the parent so Rooms/Catering/etc. share one day index.
 * @param props - Current day index, limits, and target date.
 * @returns Left/right day switch control.
 */
const DaySwitch = ({ value = 0, onChange, max, min = 0, date }: DaySwitchProps) => {
  const { t } = useTranslation();
  const numValue = value ?? 0;

  return (
    <DaySwitchBase>
      <div style={{ minWidth: 44 }}>
        {numValue > min && (
          <DaySwitchArrow onClick={() => onChange?.(numValue - 1)}>
            <Icon name="chevronleft" />
          </DaySwitchArrow>
        )}
      </div>
      <div>
        <strong>
          {numValue === -1 ? t("widget:daySwitch.arrivalPrevDay") : `${t("widget:daySwitch.day")} ${numValue + 1}`}
        </strong>
        <br />
        {format(date, "dd.MM.yyyy")}
      </div>
      <div style={{ minWidth: 44 }}>
        {max !== undefined && numValue < max && (
          <DaySwitchArrow onClick={() => onChange?.(numValue + 1)}>
            <Icon name="chevronright" />
          </DaySwitchArrow>
        )}
      </div>
    </DaySwitchBase>
  );
};

export default DaySwitch;
